module.exports = __webpack_public_path__ + "static/business_rule@2x-2bd12f9a333fec87446265913ec014a6.png";